import { queryOptions } from '@tanstack/react-query';

import { getCuInfo, getPayWallInfo } from '@/api';
import { QUERY_KEYS } from '@/constants';

export const paywallQuery = () =>
  queryOptions({
    queryKey: [QUERY_KEYS.paywall],
    queryFn: getPayWallInfo,
  });

export const cuInfoQuery = () =>
  queryOptions({
    queryKey: [QUERY_KEYS.cuInfo],
    queryFn: getCuInfo,
  });
